'use client';

import { useEffect, useState } from 'react';

/**
 * 全局错误边界:代替 Next.js 默认的英文 Application error 页。
 * 常见触发场景:部署后旧会话的 JS 与新版不匹配(详见 VersionPing 注释),
 * 刷新即可恢复;这里给出友好提示与刷新按钮。
 */
export default function GlobalError({ reset }: { error: Error; reset: () => void }) {
  const [zh, setZh] = useState(true);
  useEffect(() => {
    // Read the persisted user language (AiLumix-store.state.language) instead
    // of <html lang> (static default) or naive string search (would hit
    // user.language too).
    try {
      const obj = JSON.parse(localStorage.getItem('AiLumix-store') || '{}');
      const lang = obj?.state?.language;
      setZh(lang !== 'en');
    } catch {
      setZh(false);
    }
  }, []);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="text-4xl font-bold text-gf-accent">!</div>
      <h2 className="text-lg font-bold text-gf-text">
        {zh ? '页面暂时出了点问题' : 'Something went wrong'}
      </h2>
      <p className="max-w-sm text-sm leading-relaxed text-gf-muted">
        {zh
          ? '可能是网络波动或页面刚刚更新，请刷新后重试；若持续出现请稍后再访。'
          : 'It may be a network hiccup or the page was just updated. Please refresh and try again.'}
      </p>
      <div className="mt-2 flex items-center gap-3">
        <button
          onClick={() => reset()}
          className="rounded-lg border border-gf-border bg-gf-surface2 px-4 py-2 text-sm font-medium text-gf-text transition-colors hover:border-gf-accent/50"
        >
          {zh ? '重试' : 'Try again'}
        </button>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg bg-gf-accent px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-85"
        >
          {zh ? '刷新页面' : 'Refresh'}
        </button>
      </div>
    </div>
  );
}
